import {
  SiDatabricks,
  SiSnowflake,
  SiApachespark,
  SiAmazonwebservices,
  SiGooglecloud,
  SiDbt,
  SiApacheairflow,
  SiTerraform,
  SiKubernetes,
} from "react-icons/si";
import { FaLayerGroup } from "react-icons/fa6";
import styles from "./TechLogoGrid.module.css";
import { LuBrainCircuit } from "react-icons/lu";
import { VscAzure } from "react-icons/vsc";
import { IconType } from "react-icons";

interface Tech {
  icon: IconType;
  name: string;
}

interface TechLogoGridProps {
  technologies?: Tech[];
  label?: string;
  onDark?: boolean;
}
const defaultTech: Tech[] = [
  { icon: SiDatabricks, name: "Databricks" },
  { icon: SiSnowflake, name: "Snowflake" },
  { icon: FaLayerGroup, name: "Delta Lake" },
  { icon: SiApachespark, name: "Apache Spark" },
  { icon: VscAzure, name: "Azure" },
  { icon: SiAmazonwebservices, name: "AWS" },
  { icon: SiGooglecloud, name: "Google Cloud" },
  { icon: SiDbt, name: "dbt" },
  { icon: SiApacheairflow, name: "Apache Airflow" },
  { icon: LuBrainCircuit, name: "MLflow" },
  { icon: SiTerraform, name: "Terraform" },
  { icon: SiKubernetes, name: "Kubernetes" },
];

export function TechLogoGrid({
  technologies = defaultTech,
  label = "Ecosystem & Integrations",
  onDark = false,
}: TechLogoGridProps) {
  // This version of react is sensitive, and does not tolerate ReactNode, only JSX.Element, so I have to cast them to that.
  const bruArray: { icon: () => JSX.Element; name: string }[] = defaultTech.map(
    (item) => {
      return {
        icon: item.icon as unknown as () => JSX.Element,
        name: item.name,
      };
    },
  );

  return (
    <div
      className={[styles.wrapper, onDark ? styles.onDark : ""]
        .filter(Boolean)
        .join(" ")}
    >
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.grid}>
        {bruArray.map((tech) => (
          <div key={tech.name} className={styles.tile}>
            <span className={styles.tileIcon} aria-hidden="true">
              {<tech.icon />}
            </span>
            <span>{tech.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
